/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  container: {
    '& .selected': {
      backgroundColor: '#0078D4',
      color: 'white',
      border: '1px solid #0078D4',
    },
  },
  item: {
    display: 'inline-block',
    boxSizing: 'border-box',
    textAlign: 'center',
    width: 80,
    height: 30,
    lineHeight: '28px',
    border: '1px solid #868686',
    borderRadius: 3,
    marginRight: 9,
    marginBottom: 9,
    fontSize: 14,

    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const UstyledRadioButton = ({
  classes,
  options,
  // Do not use below two props at the same
  defaultSelectedItem,
  selectedItem,
  onSelectItem,
}) => {
  // Maintain internal state and thus support both controlled and uncontrolled component.
  const [
    internalSelectedItem,
    setInternalSelectedItem,
  ] = useState(defaultSelectedItem || selectedItem);

  const onClickOption = useCallback((option) => {
    setInternalSelectedItem(option);
    onSelectItem(option);
  }, [onSelectItem]);

  useEffect(() => {
    if (selectedItem && internalSelectedItem.key !== selectedItem.key) {
      setInternalSelectedItem(selectedItem);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  return (
    <div className={classes.container}>
      {
        options.map(option => (
          <span
            key={option.key}
            className={classNames(classes.item, 'radio-button-item', {
              selected: option.key === internalSelectedItem.key,
            })}
            onClick={() => onClickOption(option)}
          >
            {option.text}
          </span>
        ))
      }
    </div>
  );
};

UstyledRadioButton.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  selectedItem: PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  }),
  defaultSelectedItem: PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  }),
  onSelectItem: PropTypes.func,
};

UstyledRadioButton.defaultProps = {
  selectedItem: {
    key: null,
    text: null,
  },
  defaultSelectedItem: null,
  onSelectItem: () => {},
};

export const RadioButton = React.memo(withDefaultStyles(
  UstyledRadioButton,
  getStyles
));
